/* tslint:disable:max-line-length */
import React from 'react';
import classNames from 'classnames';
import { IconTypeProps } from '../types';

export const PlayIcon = ({
  className,
  style,
  onClick,
  color = 'url(#paint0_linear)',
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      style={style}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7323 7.41935L6.05484 3.96774C5.54516 3.68387 4.90323 4.04839 4.90323 4.64516V11.3548C4.90323 11.9484 5.54194 12.3161 6.05484 12.0323L11.7323 8.77419C12.2613 8.48065 12.2613 7.71613 11.7323 7.41935ZM16 8C16 3.58065 12.4194 0 8 0C3.58065 0 0 3.58065 0 8C0 12.4194 3.58065 16 8 16C12.4194 16 16 12.4194 16 8ZM1.54839 8C1.54839 4.43548 4.43548 1.54839 8 1.54839C11.5645 1.54839 14.4516 4.43548 14.4516 8C14.4516 11.5645 11.5645 14.4516 8 14.4516C4.43548 14.4516 1.54839 11.5645 1.54839 8Z"
        fill={color}
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="8"
          y1="0"
          x2="8"
          y2="16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7A38A2" />
          <stop offset="0.473958" stopColor="#E72A7A" />
          <stop offset="1" stopColor="#FFAF56" />
        </linearGradient>
      </defs>
    </svg>
  );
};
